import * as React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Camel from './common/Camel';
import theme, { Colors } from '@qnpm/q-theme';
const { scenes: { baseColor } } = Colors;
const { font, responsive: { scale } } = theme;
export default class CommonCamel extends React.PureComponent {
    render() {
        const { text } = this.props;
        return (<View style={styles.container}>
                <Camel />
                <View style={styles.textWrapper}>
                    <Text style={styles.text} numberOfLines={2}>
                        {text || '努力加载中...'}
                    </Text>
                </View>
            </View>);
    }
}
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    textWrapper: {
        width: scale(216),
        alignItems: 'center'
    },
    text: {
        fontSize: font.size.scaled.fontSizeS,
        color: baseColor.text3,
        lineHeight: scale(18),
        textAlign: 'center'
    }
});
